import React from 'react';

import { Wrapper } from './wrapper';

interface INotification {
  children?: React.ReactNode;
  title?: string;
  tone?: 'alt' | 'neutral';
  size?: 'tiny' | 'small' | 'large';
  disablePointerEvents?: boolean;
  bleedY?: boolean;
}

const Notification = ({
  children,
  bleedY,
  title,
  disablePointerEvents,
  tone,
  size,
}: INotification) => (
  <Wrapper
    title={title}
    $bleedY={bleedY}
    $disablePointerEvents={disablePointerEvents}
    $tone={tone}
    $size={size}
  >
    {size !== 'tiny' && children}
  </Wrapper>
);

export default Notification;
